<template>
  <div>
    <w-search-field class="title-bar" :width="searchWidth" @search="searchField"/>
    <el-tree
    :data="logidTableData"
    :props="defaultProps"
    @node-click="selectLogid"
    style="text-align:left"
    node-key="nodeKey"
    ref="tree"
    highlight-current
    :filter-node-method="mlFilterNode"></el-tree>
  </div>
</template>

<script>
import LmsMlAPI from '@/api/settings/log/lms-machine-learning-setting';
import { isNil, isEmpty } from 'lodash';
import WSearchField from '@/components/form/SearchField';
import msgUtils from '@/utils/message';

export default {
  name: 'WMlLogTree',
  components: {
    WSearchField,
  },
  data() {
    return {
      searchWidth: '100%',
      logidTableData: [],
      defaultProps: {
        nodeKey: 'nodeKey',
        children: 'children',
        label: 'label',
        isLeaf: 'leaf',
        showOverflowTooltip: true,
      },
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    selectLogid(value) {
      if (!isEmpty(value) && value.leaf) {
        this.$emit('selectNode', value);
      }
    },
    mlFilterNode(value, data) {
      if (!value) {
        return true;
      }
      return data.label.toLowerCase().indexOf(value.toLowerCase()) !== -1 && data.leaf === true;
    },
    searchField(value) {
      this.$refs.tree.filter(value);
    },
    /**
     * 로그아이디 그룹 목록 로드
     * @author leesy918
     * @return {[type]} [description]
     */
    loadData() {
      LmsMlAPI.getLogidList().then((response) => {
        if (response.data.success) {
          this.logidTableData = response.data.data;
          const rootData = this.$refs.tree.root;
          if (!isNil(this.logidTableData[0])) {
            this.$nextTick(() => {
              rootData.childNodes[0].expanded = true;
              this.findFirstNode(rootData.childNodes[0]);
              this.$nextTick(() => {
                const selectedLogid = this.$refs.tree.getCurrentNode();
                this.selectLogid(selectedLogid);
              });
            });
          }
        } else {
          this.$message(msgUtils.getResultMsgData(msgUtils.action.VIEW, '로그 대상 목록', false));
        }
      }).catch((e) => {
        this.$message(msgUtils.getResultMsgData(msgUtils.action.VIEW, '로그 대상 목록', false));
        throw new Error(e);
      });
    },
    findFirstNode(children) {
      if (!isNil(children.childNodes[0])) {
        children.childNodes[0].expanded = true;
        this.findFirstNode(children.childNodes[0]);
      } else {
        this.$refs.tree.setCurrentKey(children.key);
      }
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/settings/log-analysis/Pattern/components/MlLogTree.vue